import Immutable from "immutable";
import { Client } from "resourceModels";

export default class AdaMessengerPlatformRecord extends Immutable.Record({
  name: "ada_messenger",
  fullName: "Ada Messenger",
  enabled: false,

  isVisibleToClient(client: Client): boolean {
    return (
      client.hasFullSitePrivileges &&
      client.features.get("adaMessenger")
    );
  }
}) {}
